// From liquid-qex-widget, with React dependencies removed

import EventEmitter from "eventemitter3";

var POST_MESSAGES;
(function (POST_MESSAGES) {
    POST_MESSAGES["SUGGESTED_SIZE"] = "suggested_size";
    POST_MESSAGES["STEP_TRANSITION"] = "step_transition";
    POST_MESSAGES["UI_EVENT"] = "ui_event";
    POST_MESSAGES["PERSIST_SESSION"] = "persist_session";
    POST_MESSAGES["DESTROY_SESSION"] = "destroy_session";
    // synthetic
    POST_MESSAGES["FINAL_SUCCESS"] = "FINAL_SUCCESS";
    POST_MESSAGES["FINAL_FAILURE"] = "FINAL_FAILURE";
})(POST_MESSAGES || (POST_MESSAGES = {}));
var SEVERITY;
(function (SEVERITY) {
    SEVERITY["INVALID"] = "INVALID";
    SEVERITY["FATAL"] = "FATAL";
})(SEVERITY || (SEVERITY = {}));
var UI_EVENT;
(function (UI_EVENT) {
    UI_EVENT["BUTTON_CLICKED"] = "button_clicked";
})(UI_EVENT || (UI_EVENT = {}));

const DEFAULT_SETTINGS = {
    plugin_url: "https://plugin.partners.liquid.com",
    debug_logging: false,
};

var SETTLEMENT_METHOD;
(function (SETTLEMENT_METHOD) {
    SETTLEMENT_METHOD["LIQUID_PARTNER_WALLET"] = "LIQUID_PARTNER_WALLET";
    SETTLEMENT_METHOD["LIQUID_WALLET"] = "LIQUID_WALLET";
    SETTLEMENT_METHOD["BLOCKCHAIN_TRANSFER"] = "BLOCKCHAIN_TRANSFER";
})(SETTLEMENT_METHOD || (SETTLEMENT_METHOD = {}));
var SETTLEMENT_ACCOUNT_FIELD;
(function (SETTLEMENT_ACCOUNT_FIELD) {
    SETTLEMENT_ACCOUNT_FIELD["LIQUID_USED_ID"] = "LIQUID_USED_ID";
})(SETTLEMENT_ACCOUNT_FIELD || (SETTLEMENT_ACCOUNT_FIELD = {}));
var SETTLEMENT_DIRECTION;
(function (SETTLEMENT_DIRECTION) {
    SETTLEMENT_DIRECTION["FUNDING"] = "FUNDING";
    SETTLEMENT_DIRECTION["PAYOUT"] = "PAYOUT";
})(SETTLEMENT_DIRECTION || (SETTLEMENT_DIRECTION = {}));

var THEME;
(function (THEME) {
    THEME["DEFAULT"] = "default";
    THEME["LIGHT"] = "light";
    THEME["DARK"] = "dark";
    THEME["BLUE"] = "blue";
})(THEME || (THEME = {}));

var QEX_VIEW;
(function (QEX_VIEW) {
    QEX_VIEW["LOADING"] = "loading";
    QEX_VIEW["QUOTE_VIEW"] = "quoting";
    QEX_VIEW["PAYOUT_VIEW"] = "payout";
    QEX_VIEW["FUNDING_VIEW"] = "funding";
    QEX_VIEW["SUCCESS_VIEW"] = "success";
    QEX_VIEW["FAILURE_VIEW"] = "failure";
    QEX_VIEW["COMPLETE_VIEW"] = "complete";
    QEX_VIEW["COMING_SOON_VIEW"] = "coming-soon";
})(QEX_VIEW || (QEX_VIEW = {}));


class QexWidgetApi {
    constructor(elem, settings) {
        this.eventEmitter = new EventEmitter();
        this.init = (config) => {
            this.config = config;
            this.iframe = document.createElement("iframe");
            this.iframe.allow = "camera; microphone";
            this.iframe.style.margin = "0";
            this.iframe.style.padding = "0";
            this.iframe.style.border = "0";
            this.iframe.style.fontSize = "100%";
            this.iframe.style.font = "inherit";
            this.iframe.style.width = "100%";
            this.iframe.style.height = "100%";
            this.iframe.style.background = "transparent";
            this.iframe.style.overflow = "hidden";
            this.iframe.style.display = "block";
            this.iframe.style.margin = "0";
            this.iframe.style.marginTop = "10";
            this.iframe.style.position = "static";
            this.iframe.setAttribute("src", this.settings.plugin_url);
            this.elem.appendChild(this.iframe);
            window.addEventListener("message", this.handlePostMessage, false);
            this.iframe.onload = this.handleIframeLoaded;
        };
        this.handleIframeLoaded = () => {
            if (this.iframe !== undefined && this.iframe.contentWindow !== null) {
                // initialize form
                this.iframe.contentWindow.postMessage({
                    event: "initialize",
                    data: this.config,
                }, "*");
            }
        };
        this.handlePostMessage = (windowMessage) => {
            const msg = windowMessage.data;
            switch (msg.event) {
                case POST_MESSAGES.SUGGESTED_SIZE:
                    this.handleSuggestedSize(msg.data);
                    break;
            }

            this.eventEmitter.emit(msg.event, msg.data);
        };
        this.handleSuggestedSize = (size) => {
            this.elem.style.height = size.backgroundHeight.toString() + "px";
            if (this.iframe !== undefined) {
                this.iframe.style.height = size.overflowHeight.toString() + "px";
            }
        };
        this.onSizeSuggestion = (f) => {
            this.eventEmitter.on(POST_MESSAGES.SUGGESTED_SIZE, f);
        };
        this.onStepTransition = (f) => {
            this.eventEmitter.on(POST_MESSAGES.STEP_TRANSITION, f);
        };
        this.onSuccess = (f) => {
            this.eventEmitter.on(POST_MESSAGES.STEP_TRANSITION, (payload) => {
                if (payload.new_step === QEX_VIEW.SUCCESS_VIEW) {
                    f(payload.meta);
                }
            });
        };
        this.onError = (f) => {
            this.eventEmitter.on(POST_MESSAGES.STEP_TRANSITION, (payload) => {
                if (payload.new_step === QEX_VIEW.FAILURE_VIEW ||
                    payload.new_step === QEX_VIEW.COMING_SOON_VIEW) {
                    f(payload.meta);
                }
            });
        };
        this.destroy = () => {
            console.log('destroying qex');
            if (this.iframe !== undefined) {
                this.iframe.remove();
                this.iframe = undefined;
            }
            this.eventEmitter.removeAllListeners();
        }

        this.elem = elem;
        this.settings = Object.assign(Object.assign({}, DEFAULT_SETTINGS), settings);
    }
    on(event, f) {
        this.eventEmitter.on(event, f);
    }
}

var CUSTOM_STYLE;
(function (CUSTOM_STYLE) {
    CUSTOM_STYLE["CsBase"] = "cs-base";
    CUSTOM_STYLE["CsButton"] = "cs-button";
    CUSTOM_STYLE["CsError"] = "cs-error";
    CUSTOM_STYLE["CsHighlight"] = "cs-highlight";
    CUSTOM_STYLE["CsInteractive"] = "cs-interactive";
    CUSTOM_STYLE["CsSelect"] = "cs-select";
    CUSTOM_STYLE["CsSpecial"] = "cs-special";
    CUSTOM_STYLE["CsSubtext"] = "cs-subtext";
})(CUSTOM_STYLE || (CUSTOM_STYLE = {}));
const CUSTOM_STYLES = Object.values(CUSTOM_STYLE);

export { CUSTOM_STYLE, CUSTOM_STYLES, DEFAULT_SETTINGS, POST_MESSAGES, QEX_VIEW, QexWidgetApi, SETTLEMENT_ACCOUNT_FIELD, SETTLEMENT_DIRECTION, SETTLEMENT_METHOD, SEVERITY, THEME, UI_EVENT };
//# sourceMappingURL=index.es.js.map
